import { SinisterResponsible } from './types';

/**
 * Canonical sinister responsible parties. Spanish strings (with tildes) are
 * the values stored in the database AND the i18n keys — translations live in
 * `apps/common/src/i18n/locales/{lang}/common.json`.
 *
 * Use `t(opt)` from useTranslation('common') to render the label.
 */
export const SINISTER_RESPONSIBLE_OPTIONS: readonly SinisterResponsible[] = [
  'Productores',
  'Packing',
  'Logística Local',
  'Logística Internacional',
  'Exportadora',
  'Recibidor',
] as const;
